import React, { useState, useEffect, useContext } from 'react'
import classNames from 'classnames'
import { Col, Container, Row } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { Link, useLocation } from 'react-router-dom'
import { AbroadGoldenIcon, LoginForm, SignupLeftSection } from '../components'
import { conditionMatched } from '../components/layout'
import { InviteDetailsContext } from '../utils/contexts'
import { ModalProvider } from '@abroad/components'
import QuestEntryModal from './QuestEntryModal'

const Login = () => {
  const location = useLocation()
  const { inviteLinkDetails } = useContext(InviteDetailsContext)
  const query = new URLSearchParams(location?.search)
  const fName = query.get('fname')
  // const lname = query.get('lname')
  // const email = query.get('email')
  const code = query.get('e')
  const isQuestEntry = Boolean(
    code &&
      inviteLinkDetails &&
      (inviteLinkDetails?.welcomeLetter || inviteLinkDetails?.title),
  )
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    if (isQuestEntry) {
      const hasSeenModal = localStorage.getItem('hasSeenQuestEntryModal')
      if (!hasSeenModal) {
        setShowModal(true)
        localStorage.setItem('hasSeenQuestEntryModal', 'true')
      }
    }

    // Add event listener for tab/site close
    const handleBeforeUnload = () => {
      localStorage.removeItem('hasSeenQuestEntryModal')
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    // Cleanup event listener
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [isQuestEntry])

  return (
    <>
      <Helmet>
        <title>{'Abroad Platform'}</title>
        <meta name='title' content={'Abroad Platform'}></meta>
        <meta property='og:title' content={'Abroad Platform'}></meta>
        <meta property='twitter:title' content={'Abroad Platform'}></meta>
      </Helmet>
      <main>
        <ModalProvider>
          {isQuestEntry && (
            <QuestEntryModal
              firstName={fName}
              show={showModal}
              onClose={() => setShowModal(false)}
            />
          )}
          <Container fluid className='px-0'>
            <Row className='vh-100 row g-0 bg-abroad-blue'>
              {isQuestEntry && (
                <>
                  <div className='d-sm-flex d-md-none justify-content-center align-items-center'>
                    <AbroadGoldenIcon />
                  </div>
                  <Col
                    xxl={2}
                    xl={1}
                    lg={1}
                    md={1}
                    className='d-lg-flex d-none bg-abroad-blue'></Col>
                  <Col
                    xxl={5}
                    xl={5}
                    lg={5}
                    md={8}
                    sm={12}
                    className='d-lg-flex justify-content-center bg-abroad-blue text-break'>
                    <SignupLeftSection isQuestEntry={true} />
                  </Col>
                </>
              )}
              <Col
                className={`onboard bg-abroad-blue ${
                  isQuestEntry ? 'negative-margin-lg' : ''
                } `}>
                <div className='h-100 d-flex flex-column align-items-center'>
                  {isQuestEntry && (
                    <div className='d-none d-md-flex justify-content-center align-items-center'>
                      {' '}
                      <AbroadGoldenIcon />{' '}
                    </div>
                  )}
                  {!isQuestEntry && (
                    <div className='d-flex justify-content-center align-items-center'>
                      {' '}
                      <AbroadGoldenIcon />{' '}
                    </div>
                  )}
                  <section
                    className={classNames('onboard-wrapper', {
                      'h-lg-65': !conditionMatched,
                    })}>
                    <LoginForm isQuestEntry={isQuestEntry} />
                  </section>
                  <div
                    className={`d-flex w-100 justify-content-center align-items-center s8 my-3`}>
                    <div className='page-bottom-link'>
                      <span className='text-white'>New to Abroad?&nbsp;</span>
                      <Link
                        to={
                          isQuestEntry
                            ? `/account?mode=invite&${
                                query ? query.toString() : ''
                              }`
                            : '/account'
                        }
                        title='Sign up'>
                        <span>Sign up for free</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </ModalProvider>
      </main>
    </>
  )
}

export default Login
